import React, { useCallback } from 'react';
import Input from '@dealroadshow/uikit/core/components/Input';
import IconFiltering from '@dealroadshow/uikit/core/components/Icon/IconFiltering';
import debounce from 'lodash/debounce';
import { useResearchContext } from '@/finsight/application/Research/ResearchContext';
import URL from '@/finsight/Router/urlConstants';
import { useRouter } from 'next/router';
import Router, { removeQueryParams } from '@/Framework/Router';
import { addQueryParams } from '@/Framework/Router/nextRouter';

import styles from './styles.scss';

const SearchContainer = () => {
  const {
    query,
    pathname,
  } = useRouter();
  const {
    paginate,
    getResearchForAllGroups,
    searchFieldValue,
    setSearchFieldValue,
  } = useResearchContext();

  const debouncedSearchRequest = useCallback(debounce((search) => {
    paginate(1);
    getResearchForAllGroups({
      page: 1,
      search,
    });
    if (pathname.includes(URL.NRSRO_RESEARCH)) {
      Router.push({
        query: search
          ? addQueryParams(query, { q: search })
          : removeQueryParams(query, ['q']),
      }, undefined, { shallow: true });
    }
  }, 200), []);

  const onChange = ({ target }) => {
    setSearchFieldValue(target.value);

    debouncedSearchRequest(target.value);
  };

  return (
    <Input
      onChange={ onChange }
      isNarrow
      isClearable
      className={ styles.inputSearch }
      icon={ IconFiltering }
      placeholder="Filter by Name"
      iconPosition="left"
      dataTest="researchSearchInput"
      name="researchSearchInput"
      // @ts-ignore
      value={ searchFieldValue }
    />
  );
};

export default SearchContainer;
